import { getCustomer } from '../../../../../util/user';

export const initialState = {
	customer: getCustomer(),
	items: [],
	itemsMap: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined,
	deletingLinesAggsIds: {},
	deletedLinesAggsIds: {},
	errorMessagesForDeleting: {}
};

export default initialState;
